/**
 * Dr. Herança Tenant - Routes Configuration
 * 
 * Routes are now generated from the configuration in config.ts
 * Uses core routes utilities and extends with tenant-specific components
 */

import { SuspenseLoader } from 'src/core/components';

// Import core routes utilities
import {
  createCoreLayoutResolver,
  createExtendedComponentResolver,
  createPrivateRoute,
  createRedirectIfAuthorized,
} from 'src/core/routes';

// Import configuration and route builder
import { drherancaConfig } from './config';
import { buildRoutes } from 'src/core/routing/routeBuilder';
import { DrHerancaComponent } from './routesTypes';

// Auth Guards - tenant-specific redirect paths
const PrivateRoute = createPrivateRoute('/');
const RedirectIfAuthorized = createRedirectIfAuthorized('/inventories/list');

// Layout resolver: uses core layouts
const layoutResolver = createCoreLayoutResolver();

// Component resolver: extends core components with tenant-specific components
// Map enum values to import functions, but also support string paths for backward compatibility
const tenantComponentMap: Record<string, () => Promise<{ default: React.ComponentType<any> }>> = {
  // Tenant-specific pages - using enum values as keys
  [DrHerancaComponent.Home]: () => import('./pages/home'),
  [DrHerancaComponent.LandingCalculadoraInventario]: () => import('./pages/landing/CalculadoraInventario'),
  [DrHerancaComponent.InventoriesList]: () => import('./pages/inventories/List'),
  [DrHerancaComponent.InventoryDelete]: () => import('./pages/inventory/Delete'),
  [DrHerancaComponent.InventoryFamilyTree]: () => import('./pages/inventory/FamilyTree'),
  [DrHerancaComponent.InventoryHome]: () => import('./pages/inventory/Home'),
  [DrHerancaComponent.InventoryPrintPreview]: () => import('./pages/inventory/PrintPreview'),
  [DrHerancaComponent.UserProfile]: () => import('./pages/user/Profile'),
  // Also support string paths for backward compatibility
  './pages/home': () => import('./pages/home'),
  './pages/landing/CalculadoraInventario': () => import('./pages/landing/CalculadoraInventario'),
  './pages/inventories/List': () => import('./pages/inventories/List'),
  './pages/inventory/Delete': () => import('./pages/inventory/Delete'),
  './pages/inventory/FamilyTree': () => import('./pages/inventory/FamilyTree'),
  './pages/inventory/Home': () => import('./pages/inventory/Home'),
  './pages/inventory/PrintPreview': () => import('./pages/inventory/PrintPreview'),
  './pages/user/Profile': () => import('./pages/user/Profile'),
};

const componentResolver = createExtendedComponentResolver(tenantComponentMap);

// Build routes from configuration
const drherancaRoutes = buildRoutes(
  drherancaConfig.routeConfig || [],
  {
    layoutResolver,
    componentResolver,
    PrivateRoute,
    RedirectIfAuthorized,
    SuspenseLoader,
  }
);

export default drherancaRoutes;
